import React, { useEffect, useState } from "react";
import { FaBars, FaEnvelope, FaPhoneAlt, FaTimes } from "react-icons/fa";
import "./Navbar.css";

const Navbar = ({ t, language, languages, onLanguageChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setHasScrolled(window.scrollY > 12);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <div className="top-bar">
        <div className="top-bar-inner">
          <span className="top-message">{t.topLine || "Connecting Pakistan's Talent with Saudi Arabia & the Middle East Since 1998"}</span>
          <a href="tel:+923335127407"><FaPhoneAlt /> +92 333 5127407</a>
          <a href="mailto:pakarabian@icloud.com"><FaEnvelope /> pakarabian@icloud.com</a>
          <div className="language-switcher top-language" aria-label={t.language}>
            {languages.map((option) => (
              <button
                className={language === option.code ? "active" : ""}
                key={option.code}
                type="button"
                onClick={() => onLanguageChange(option.code)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <nav className={`navbar ${hasScrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          <a href="#home" className="navbar-logo" onClick={closeMenu}>
            <span className="navbar-logo-panel">
              <img src="/images/pamslogo2-nobg.png" alt="Pak Arabian" className="navbar-logo-img" />
            </span>
            <span className="navbar-brand-text">
              <strong>Pak Arabian Manpower Services Pakistan</strong>
              <span>Government License No. 2511</span>
            </span>
          </a>

          <button
            className="menu-toggle"
            type="button"
            aria-label={isOpen ? t.closeMenu : t.openMenu}
            aria-expanded={isOpen}
            onClick={() => setIsOpen((current) => !current)}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>

          <ul className={`nav-links ${isOpen ? "open" : ""}`}>
            <li><a href="#home" onClick={closeMenu}>{t.home || "Home"}</a></li>
            <li><a href="#about" onClick={closeMenu}>{t.about || "About Us"}</a></li>
            <li><a href="#services" onClick={closeMenu}>{t.services || "Industries"}</a></li>
            <li><a href="#appreciations" onClick={closeMenu}>{t.gallery || t.trust || "Gallery"}</a></li>
            <li><a href="#contact" onClick={closeMenu}>{t.contact || "Contact Us"}</a></li>
            <li><a href="#contact" onClick={closeMenu} className="nav-cta">{t.requestManpower || "Request Manpower"}</a></li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
